import { RootState } from 'rootReducer';

export const getAuth = (state: RootState) => state.auth;
export const getUser = (state: RootState) => state.auth.user;
export const getToken = (state: RootState) => state.auth.token;
export const getError = (state: RootState) => state.auth.error;
export const get2faDeviceToken = (state: RootState) => state.auth.twoFactor.device2faToken;
export const get2faQrUrl = (state: RootState) => state.auth.twoFactor.qrUrl;
export const getIsCookieBannerAccepted = (state: RootState) => state.auth.cookieBanner;
